export const PORTAL_LOGADO = 'PORTAL_LOGADO';
export const PORTAL_LOGAR_SUCCESS = 'PORTAL_LOGAR_SUCCESS';
export const PORTAL_LOGAR = 'PORTAL_LOGAR';
export const PORTAL_LOGOUT = 'PORTAL_LOGOUT';
export const PORTAL_IP = 'PORTAL_IP';
export const PORTAL_BUSCA = 'PORTAL_BUSCA';
export const PORTAL_MATRICULAS = 'PORTAL_MATRICULAS';
